import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapTableInitiativeUncertaintiesRoute extends Route {
  @service store;

  async model() {
    const initiative = this.modelFor('backlog.initiatives.initiative');
    const uncertainties = await initiative.hasMany('uncertainties').load();
    await this.store.query('uncertainty', {
      filter: {
        archived: true,
        initiative: initiative.id,
      },
    });
    return {
      initiative,
      uncertainties,
    };
  }
}

export default instrumentRoutePerformance(
  RoadmapTableInitiativeUncertaintiesRoute,
);
